export default __webpack_public_path__ + "static/IBMPlexSans-ExtraLightItalic-60589330b8f1ec04a579a035527deae1.woff2";